// @flow

import * as React from 'react';
import '../../src/App.css';

type Props = {
  title: Array<*>
};

type State = {};

class Header extends React.Component<Props, State> {
  render() {
    return (
      <div className="header">
        <p>{this.props.title}</p>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js